const ForgotPassword = {

    // FIELDS
    "otp": "ओटीपी",

    // BUTTON
    "send_otp": "ओटीपी भेजें",
    "verify_otp": "ओटीपी सत्यापित करें",

    // TOAST
    "success_sent_otp": "ओटीपी सफलतापूर्वक भेजा गया। अपना ईमेल सत्यापित करने के लिए ओटीपी दर्ज करें।",
    "success_verified_otp": "ओटीपी सफलतापूर्वक सत्यापित हुआ। आप अब अपना पासवर्ड बदल सकते हैं।",
    "success_change_password": "पासवर्ड सफलतापूर्वक बदल दिया गया। आप अब नए पासवर्ड के साथ लॉगिन कर सकते हैं।",

    // ERROR
    "error_otp": "ओटीपी दर्ज करें",
    "error_otp_digit": "ओटीपी ठीक 4 अंकों का होना चाहिए",

}

export default ForgotPassword;